import React, { useMemo } from 'react';
import SearchTreeStyled from './SearchTreeStyled';
import { useForm } from 'react-hook-form';
import { Box, useTheme } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TreeItem from '@material-ui/lab/TreeItem';
import FolderIcon from '@material-ui/icons/Folder';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeView from '@material-ui/lab/TreeView';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { useSelector, useDispatch } from 'dva';
import { useLocation, history } from 'umi';
import webStorage from '@/utils/storageManager';
import qs from 'qs';

const filterTree = (list) => {
  if (!list) {
    return [];
  }
  const filTrees = [];
  for (let i = 0; i < list.length; i++) {
    if (list[i].children.length > 0) {
      filTrees.push({ ...list[i], children: filterTree(list[i].children) });
    } else if (list[i].status === 1) {
      filTrees.push(list[i]);
    }
  }
  return filTrees;
};
const SearchTree = (props) => {
  // const dispatch = useDispatch();
  // const { query } = props;
  const location = useLocation();
  const { handleSearch } = props;
  const {
    tagTreeList,
    setTagId,
    expanded,
    setExpanded,
    treeExpanded,
    setTreeExpanded,
    refreshTime,
  } = props;
  const { query, pathname } = location;
  // const {
  //   // signUpDateEnd,
  //   // signUpDateStart,
  // } = query;
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    // control,
    // reset,
    // setValue,
    // getValues,
    // watch,
  } = useForm({
    defaultValues: {
      // label,
    },
  });

  const { favoriteList, checked } = useSelector((state) => state.labelManage);
  const ExpandMore = (
    <>
      <ExpandMoreIcon sx={{ width: 15, color: '#000000' }} />
    </>
  );

  const ChevronRight = (
    <>
      <ChevronRightIcon sx={{ width: 15, color: '#000000' }} />
    </>
  );

  //查询
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
    };
    handleSearch && handleSearch(propsSubmitData);
  };

  // const renderTree = (nodes) =>
  //   Array.isArray(nodes) &&
  //   nodes.map((item) => (
  //     <StyledTreeItem
  //       key={item.id}
  //       nodeId={item.id}
  //       labelText={item.name}
  //       labelIcon={item.type===7?LocalOffer:Folder}
  //       // children={renderTree(item.children)}
  //     >
  //       {renderTree(item.children)}
  //     </StyledTreeItem>
  //   ));

  // 收藏夹展开
  const handleFavoriteFocus = (data) => {
    setTagId(data.tagId);
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        id: String(data.tagId),
      })}`,
    );
  };

  const handleFocus = (data) => {
    webStorage.delete('DELETE_TAG');
    // 7是文件夹 非7是标签
    if (data.type !== 7) {
      setTagId(data.id);
      history.replace(
        `${pathname}?${qs.stringify({
          ...query,
          id: String(data.id),
        })}`,
      );
    }
  };

  const renderTree = (nodes) => (
    <TreeItem
      key={nodes.id}
      nodeId={nodes.id}
      label={
        <Box
          data-log={
            !Array.isArray(nodes.children) || nodes.children.length === 0
              ? JSON.stringify({
                  oid: 'btn_user_profile_label_management_list_label_data',
                  events: ['_ev', '_ec'],
                  params: {
                    id: nodes.id,
                  },
                })
              : null
          }
          className="label-title"
          sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}
        >
          {nodes.type === 7 ? (
            <FolderIcon
              sx={{ width: 15, color: '#000000', marginRight: '7px' }}
            ></FolderIcon>
          ) : (
            <LocalOfferIcon
              sx={{ width: 15, marginRight: '7px', color: '#000000' }}
            />
          )}
          {nodes.name}
        </Box>
      }
      onClick={() => handleFocus(nodes)}
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  // 树形展开
  const handleTreeToggle = (event, nodeIds) => {
    setTreeExpanded(nodeIds);
  };

  const onChangeChecked = () => {
    dispatch({
      type: 'labelManage/checkedTreeData',
      payload: {
        checked,
      },
    });
  };

  const tagTreeListChecked = useMemo(() => {
    const newTagTreeList = tagTreeList?.length
      ? JSON.parse(JSON.stringify(tagTreeList))
      : [];
    return checked ? filterTree(newTagTreeList) : newTagTreeList || [];
  }, [checked, refreshTime, tagTreeList?.length]);
  const favoriteListChecked = useMemo(() => {
    let arr = [];
    if (Array.isArray(favoriteList)) {
      if (checked) {
        arr = favoriteList.filter((item) => item.status === 1) || [];
      } else {
        arr = favoriteList;
      }
    }
    return arr;
  }, [checked, refreshTime, favoriteList?.length]);
  return (
    <SearchTreeStyled theme={theme}>
      <FormControlLabel
        onChange={onChangeChecked}
        control={<Checkbox checked={checked} />}
        label={<span className="tree-check-style">仅显示启用标签</span>}
      />
      {/* 收藏夹 */}
      <Box className="tree-content">
        <TreeView
          aria-label="icon expansion"
          defaultCollapseIcon={ExpandMore}
          defaultExpandIcon={ChevronRight}
          defaultEndIcon={<div style={{ width: 15 }} />}
          sx={{
            flexGrow: 1,
            maxWidth: 400,
            // overflowY: 'auto',
            color: '#000000',
          }}
          expanded={expanded}
          onNodeToggle={handleToggle}
        >
          {/* {favoriteList && favoriteList.map((i) => renderFavoriteTree(i))} */}
          <TreeItem
            label={
              <Box
                className="label-title"
                sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}
              >
                <FolderIcon
                  sx={{ width: 15, color: '#000000', marginRight: '7px' }}
                ></FolderIcon>
                收藏夹
              </Box>
            }
            nodeId={999}
          >
            {favoriteListChecked.map((i) => (
              <TreeItem
                key={i.id}
                nodeId={i.id}
                label={
                  <Box
                    data-log={JSON.stringify({
                      oid: 'btn_user_profile_label_management_list_label_data',
                      events: ['_ev', '_ec'],
                      params: {
                        tag_id: i.tagId,
                      },
                    })}
                    className="label-title"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      p: 0.5,
                      pr: 0,
                    }}
                  >
                    {i.type === 7 ? (
                      <FolderIcon
                        sx={{
                          width: 15,
                          color: '#000000',
                          marginRight: '7px',
                        }}
                      ></FolderIcon>
                    ) : (
                      <LocalOfferIcon
                        sx={{
                          width: 15,
                          marginRight: '7px',
                          color: '#000000',
                        }}
                      />
                    )}
                    {i.name}
                  </Box>
                }
                onClick={() => handleFavoriteFocus(i)}
              ></TreeItem>
            ))}
          </TreeItem>
        </TreeView>
        <form onSubmit={handleSubmit(handleSubmitSuccess)}>
          <div className="tree-list-wrap">
            {/* 树形 */}
            <TreeView
              defaultCollapseIcon={ExpandMore}
              defaultExpandIcon={ChevronRight}
              defaultEndIcon={<div style={{ width: 15 }} />}
              sx={{
                flexGrow: 1,
                maxWidth: 400,
                // maxHeight: 300,
                // overflowY: 'auto',
                color: '#000000',
              }}
              onNodeToggle={handleTreeToggle}
              expanded={treeExpanded}
            >
              {tagTreeListChecked &&
                tagTreeListChecked.map((i) => renderTree(i))}
            </TreeView>
          </div>
        </form>
      </Box>
    </SearchTreeStyled>
  );
};

export default SearchTree;
